import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckRegistrationMasterdataComponent } from './truck-registration-masterdata.component';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    TruckRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TruckRegistrationMasterdataModule { }
